module.exports = __webpack_public_path__ + "img/catering1.e8432a08.jpg";